import {User as types} from './types'
import {apiPrivate} from '../api'
import {USER_PROFILE} from '../endpoints'
import {endpoint as endpointText} from '../common/text'
import {push} from 'react-router-redux'
import loginActions from '../sections/login/actions/login'

export class User {

  static getLocal() {
    let parsed = null
    try {
      const data = localStorage.getItem('user')
      if (data !== null) {
        parsed = JSON.parse(data)
      }
    } catch (err) {
      console.log(err)
    }
    return parsed
  }

  static storeLocally(user) {
    try {
      const data = JSON.stringify(user)
      localStorage.setItem('user', data)
    } catch (err) {
      console.log(err)
    }
  }

  static updateApiToken(token) {
    apiPrivate.defaults.headers.Authorization = token
  }

  static setFirstTime(id, email, missingProfileInformation, name, lastName, permissions, token, profilePicture, fbUser, propagateLogin = true) {

    const user = {
      id,
      email,
      missingProfileInformation,
      name,
      lastName,
      permissions,
      token,
      profilePicture,
      fbUser
    }

    User.storeLocally(user)
    User.updateApiToken(token)

    if (propagateLogin) User.propagateLogin(user)

    return {
      type: types.SET_FIRST_TIME,
      user,
    }
  }

  static propagateLogin(payload) {
    const iframe = document.getElementById('landing')
    if (!iframe) return
    const win = iframe.contentWindow
    win.postMessage(JSON.stringify({type: 'login', payload: payload}), '*')
  }

  static propagateLogout() {
    const iframe = document.getElementById('landing')
    if (!iframe) return
    const win = iframe.contentWindow
    win.postMessage(JSON.stringify({type: 'logout', payload: {}}), '*')
  }

  static logOut(propagateLogout = true) {

    const user = {
      id: 0,
      email: '',
      missingProfileInformation: [],
      name: '',
      lastName: '',
      permissions: [],
      profilePicture: '',
      token: '',
      items: 0,
      phone: '',
    }

    User.storeLocally(user)
    User.updateApiToken('')

    if (propagateLogout) User.propagateLogout()

    return {
      type: types.LOG_OUT,
      user,
    }
  }

  static updateUserInfo() {
    return function(dispatch) {

      dispatch({
        type: types.UPDATE_USER_INFO,
      })

      return apiPrivate.get(USER_PROFILE + '/user/profile')
        .then(response => {

          const data = response.data.description

          const local = User.getLocal()

          const user = {
            id: data.ID,
            email: data.Email,
            missingProfileInformation: data.MissingProfileInformation,
            name: data.Name,
            lastName: data.LastName,
            profilePicture: data.ProfilePicture.Url,
            items: data.ItemAmount,
            phone: data.Phone,
          }

          const newUser = {...local, ...user}

          User.storeLocally(newUser)
          dispatch(User.updateUserInfoSuccess(newUser))
          return newUser
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(User.updateUserInfoFail(message))
              return
            }
            message = error.response.data.description
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(User.updateUserInfoFail(message))
          return null
        })

    }
  }

  static updateUserInfoSuccess(data) {
    return {
      type: types.UPDATE_USER_INFO_SUCCESS,
      payload: {
        user: data,
      },
    }
  }

  static updateUserInfoFail(error) {
    console.log(error)
    return {
      type: types.UPDATE_USER_INFO_FAIL,
      payload: {
        error,
      },
    }
  }

  static updateMissingInfo() {
    return function(dispatch) {

      dispatch({
        type: types.UPDATE_MISSING_INFO,
      })

      return apiPrivate.get(USER_PROFILE + '/user/missingInformation')
        .then(response => {

          const data = response.data.description

          const local = User.getLocal()

          const user = {
            missingProfileInformation: data.missingInformation,
          }

          User.storeLocally({...local, ...user})
          dispatch(User.updateMissingInfoSuccess({...local, ...user}))
          return {...local, ...user}
        }, error => {
          let message = ''
          if (error.response) {
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(User.updateMissingInfoFail(message))
        })

    }
  }

  static updateMissingInfoSuccess(data) {
    return {
      type: types.UPDATE_MISSING_INFO_SUCCESS,
      payload: {
        user: data,
      },
    }
  }

  static updateMissingInfoFail(error) {
    console.log(error)
    return {
      type: types.UPDATE_MISSING_INFO_FAIL,
      payload: {
        error,
      },
    }
  }

}



// WEBPACK FOOTER //
// ./src/state/actions.js